import { version } from "../../package.json";

export function logThemeInfo() {
  console.log(`Petits Gestes v${version} (${import.meta.env.MODE})`);
}
